import { Link } from 'react-router-dom';

interface IMarketingBannerContainerProps {
  className?: string;
  bannerDesktop: string;
  bannerTablet: string;
  bannerMobile: string;
  link: string;
}

export function MarketingBannerContainer({
  className,
  bannerDesktop,
  bannerTablet,
  bannerMobile,
  link,
}: IMarketingBannerContainerProps) {
  return (
    <div className={`mb-8 ${className}`}>
      <Link className='flex justify-center' to={link}>
        <img src={bannerDesktop} className='hidden lg:block' />
        <img src={bannerTablet} className='hidden md:block lg:hidden' />
        <img src={bannerMobile} className='block md:hidden' />
      </Link>
    </div>
  );
}
